module.exports = __webpack_public_path__ + "img/collage_conocenos.a22d9c5f.png";